import CounterStyle from '../CounterStyle';

export const upperAlpha = CounterStyle.alphabeticFromUnicodeRange(65, 26);

export default upperAlpha;
